import { constant } from './I18nConstants'
let initialState = {
  i18n: {}
}


const I18nMessagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constant.I18N_MESSAGES_FETCH_IN_PROGRESS:
      return { ...state, getI18nMessagesInProgress: true };
    case constant.I18N_MESSAGES_FETCH_COMPLETE:
      return { ...state, getI18nMessagesInProgress: false, i18n: action.data };
    default:
      return state;
  }
}

export default I18nMessagesReducer;